import React from 'react';
import cx from 'classnames';
import styled from 'styled-components';

const StyledFormLabel = styled.label`
    font-size: 1rem;
    line-height: 1.5rem;
    margin-bottom: 0.125rem;
`;
export interface FormLabelProps {
    className?: string;
    id?: string;
    htmlFor?: string;
    children?: React.ReactNode;
}

const FormLabel: React.FC<FormLabelProps> = ({ htmlFor, className, children, ...props }) => {
    return (
        <StyledFormLabel htmlFor={htmlFor} className={cx(className)} {...props}>
            {children}
        </StyledFormLabel>
    );
};

export default FormLabel;
